import { Link } from '../Link'

interface Props {
  title: string
  icon: string
  path: string
}

const TipsButton = ({ title, icon, path }: Props): React.ReactElement => {
  return (
    <Link to={path}>
      <div className="gradient-border-container w-full rounded shadow-card">
        <div className="bg-white p-2 hover:bg-pink-light transition-colors duration-300 min-h-[150px] flex flex-col items-center justify-center">
          <img alt={title} className="max-h-11 max-w-full mb-2" src={icon} />
          <p className="block font-semibold text-purple text-center">{title}</p>
        </div>
      </div>
    </Link>
  )
}

export default TipsButton
